/* Off-the-pipe ("marker only") previews for SpecMark and DuraMark.
   Needs specmark-preview.js loaded first (uses window.specmarkBuildRow and the size/colour tables).
   renderSpecMarkFlat(svg, {sizeKey|spec, text, textColor, markerColor, arrow, sameDirection})  (the pre-coiled marker)
   renderDuraMarkFlat(svg, {sizeKey, text, textColor, markerColor})
   Pass fit:true to crop the empty space above and below (product pages). */
(function(){
  var NS = 'http://www.w3.org/2000/svg';
  var FONT = '"Helvetica Bold Craftmark", "Helvetica Neue", Helvetica, Arial, sans-serif';
  var CAP = 0.72, ROW_PITCH = 1.45;

  function el(name, attrs, parent){
    var e = document.createElementNS(NS, name);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function clear(svg){ while (svg.firstChild) svg.removeChild(svg.firstChild); }
  function uid(p){ return p + Math.random().toString(36).slice(2, 7); }
  function shadow(defs, id){
    var f = el('filter', {id:id, x:'-10%', y:'-20%', width:'120%', height:'150%'}, defs);
    el('feDropShadow', {dx:0, dy:6, stdDeviation:9, 'flood-color':'#000', 'flood-opacity':'.22'}, f);
  }
  function stops(grad, list){ list.forEach(function(s){ el('stop', {offset:s[0], 'stop-color':s[1]}, grad); }); }

  // SpecMark: ships pre-coiled. Shown as the coiled marker lying on its side, open end on the left
  // (white inside visible), legend rows wrapping around it the same way they do on the pipe.
  function renderSpecMarkFlat(svg, o){
    var S = window.SPECMARK_SIZES || {};
    var spec = o.spec || S[o.sizeKey] || S.C;
    clear(svg);
    var W = 1000, H = 440;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var D = spec.strap ? spec.odMin * 0.8 : spec.odMin;          // coil is sprung tighter than the pipe it fits
    var ppi = Math.min(740 / spec.width, 300 / D);
    var len = spec.width * ppi, r = D * ppi / 2, ex = Math.max(10, r * 0.34);
    var x0 = (W - len) / 2 + ex / 2, x1 = x0 + len, cy = H / 2 - 6;
    var id = uid('sc'), defs = el('defs', {}, svg);
    var shade = el('linearGradient', {id:id + '-shade', x1:0, y1:0, x2:0, y2:1}, defs);
    stops(shade, [['0','rgba(0,0,0,.5)'],['.08','rgba(0,0,0,.2)'],['.22','rgba(255,255,255,.3)'],['.34','rgba(255,255,255,.08)'],['.55','rgba(0,0,0,0)'],['.8','rgba(0,0,0,.22)'],['1','rgba(0,0,0,.58)']]);
    var inner = el('linearGradient', {id:id + '-in', x1:0, y1:0, x2:1, y2:1}, defs);
    stops(inner, [['0','#c9c9c4'],['.45','#efefeb'],['1','#ffffff']]);
    var sh = el('radialGradient', {id:id + '-sh', cx:.5, cy:.5, r:.5}, defs);
    stops(sh, [['0','rgba(0,0,0,.28)'],['1','rgba(0,0,0,0)']]);

    // floor shadow
    el('ellipse', {cx:(x0 + x1) / 2, cy:cy + r + Math.min(18, r * 0.25), rx:len / 2 + ex, ry:Math.max(8, Math.min(26, r * 0.22)), fill:'url(#' + id + '-sh)'}, svg);

    // body: the tube plus the rounded far end
    var bodyD = 'M' + x0 + ',' + (cy - r) + 'H' + x1 + 'A' + ex + ',' + r + ' 0 0 1 ' + x1 + ',' + (cy + r) + 'H' + x0 + 'Z';
    el('clipPath', {id:id + '-clip'}, defs).appendChild(el('path', {d:bodyD}));
    var body = el('g', {'clip-path':'url(#' + id + '-clip)'}, svg);
    el('rect', {x:x0 - 2, y:cy - r, width:len + ex + 4, height:2 * r, fill:o.markerColor}, body);
    var capPx = spec.text * ppi, pitch = capPx * ROW_PITCH;
    var rowO = {text:o.text, textColor:o.textColor, arrow:o.arrow, sameDirection:o.sameDirection};
    var order = [];
    for (var k = -6; k <= 6; k++) if (k !== 0) order.push(k);
    order.sort(function(a, b){ return Math.abs(b) - Math.abs(a); }); order.push(0);
    order.forEach(function(k){
      var th = k * pitch / r;
      if (Math.abs(th) >= Math.PI / 2 - 0.02) return;
      var y = cy + r * Math.sin(th), sq = Math.cos(th);
      var g = el('g', {transform:'translate(0,' + y + ') scale(1,' + sq + ') translate(0,' + (-y) + ')'}, body);
      window.specmarkBuildRow(g, (x0 + ex + x1) / 2, y, capPx, (len - ex) * 0.9, rowO, k % 2 !== 0); // clear of the open end
    });
    el('rect', {x:x0 - 2, y:cy - r, width:len + ex + 4, height:2 * r, fill:'url(#' + id + '-shade)'}, body);
    el('path', {d:bodyD, fill:'none', stroke:'rgba(0,0,0,.3)', 'stroke-width':1.5}, svg);

    // open end: thin marker wall, white inside, and the overlapping edge of the coil
    var wall = Math.max(2.5, r * 0.045);
    el('ellipse', {cx:x0, cy:cy, rx:ex, ry:r, fill:o.markerColor, stroke:'rgba(0,0,0,.35)', 'stroke-width':1.2}, svg);
    el('ellipse', {cx:x0, cy:cy, rx:ex - wall * 0.45, ry:r - wall, fill:'url(#' + id + '-in)'}, svg);
    var ri = (r - wall) * 0.86, exi = (ex - wall * 0.45) * 0.86;
    el('path', {d:'M' + x0 + ',' + (cy - r + wall) + 'A' + exi + ',' + ri + ' 0 0 0 ' + (x0 - exi * 0.5) + ',' + (cy + ri * 0.87), fill:'none', stroke:'rgba(0,0,0,.18)', 'stroke-width':Math.max(1, wall * 0.5)}, svg);
    if (o.fit) svg.setAttribute('viewBox', '0 ' + (cy - r - 20) + ' ' + W + ' ' + (2 * r + 60)); // trim empty space above/below
    return spec;
  }

  // DuraMark: the label by itself (ships without a border), with one corner peeled up.
  function renderDuraMarkFlat(svg, o){
    var S = window.DURAMARK_SIZES || {};
    var spec = S[o.sizeKey] || S.MD;
    clear(svg);
    var W = 1000, H = 440;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var pad = 0;
    var ppi = Math.min(860 / (spec.width + 2 * pad), 340 / (spec.height + 2 * pad));
    var lw = (spec.width + 2 * pad) * ppi, lh = (spec.height + 2 * pad) * ppi;
    var lx = (W - lw) / 2, ly = (H - lh) / 2 - 4;
    var w = spec.width * ppi, h = spec.height * ppi, x = lx + pad * ppi, y = ly + pad * ppi;
    var id = uid('df'), defs = el('defs', {}, svg);
    shadow(defs, id + '-sh');
    var flapG = el('linearGradient', {id:id + '-flap', x1:0, y1:0, x2:1, y2:1}, defs);
    stops(flapG, [['0','#f4f4f0'],['1','#d6d6cf']]);

    // label
    var c = Math.min(h * 0.45, w * 0.12, 60); // size of the peeled corner
    var x2 = x + w, y2 = y + h;
    var clip = el('clipPath', {id:id + '-clip'}, defs);
    el('path', {d:'M' + x + ',' + y + 'H' + x2 + 'V' + (y2 - c) + 'L' + (x2 - c) + ',' + y2 + 'H' + x + 'Z'}, clip);
    el('path', {d:'M' + x + ',' + y + 'H' + x2 + 'V' + (y2 - c) + 'L' + (x2 - c) + ',' + y2 + 'H' + x + 'Z', fill:o.markerColor, filter:'url(#' + id + '-sh)'}, svg); // drop shadow
    var g = el('g', {'clip-path':'url(#' + id + '-clip)'}, svg);
    el('rect', {x:x, y:y, width:w, height:h, fill:o.markerColor}, g);
    var FS = 100, tg = el('g', {}, g);
    var t = el('text', {x:0, y:0, 'font-family':FONT, 'font-weight':'700', 'font-size':FS, 'dominant-baseline':'central', 'text-anchor':'middle', fill:o.textColor}, tg);
    t.textContent = (o.text || ' ').toUpperCase();
    var tb = t.getBBox();
    var capPx = spec.text * ppi, maxW = w - 2 * (Math.max(10, 0.25 * ppi) + c);
    var s = Math.min(capPx / (FS * CAP), maxW / Math.max(1, tb.width));
    tg.setAttribute('transform', 'translate(' + (x + w / 2) + ',' + (y + h / 2) + ') scale(' + s + ')');
    el('path', {d:'M' + x + ',' + y + 'H' + x2 + 'V' + (y2 - c) + 'L' + (x2 - c) + ',' + y2 + 'H' + x + 'Z', fill:'none', stroke:'rgba(0,0,0,.25)', 'stroke-width':1.2}, svg);

    // peeled corner: the label's white adhesive side folded back over itself
    el('path', {d:'M' + (x2 - c) + ',' + y2 + 'L' + x2 + ',' + (y2 - c) + 'L' + (x2 - c * 0.92) + ',' + (y2 - c * 0.92) + 'Z', fill:'rgba(0,0,0,.18)', transform:'translate(3,3)'}, svg);
    el('path', {d:'M' + (x2 - c) + ',' + y2 + 'L' + x2 + ',' + (y2 - c) + 'L' + (x2 - c * 0.92) + ',' + (y2 - c * 0.92) + 'Z', fill:'url(#' + id + '-flap)', stroke:'rgba(0,0,0,.2)', 'stroke-width':1}, svg);
    if (o.fit) svg.setAttribute('viewBox', '0 ' + (ly - 20) + ' ' + W + ' ' + (lh + 52)); // trim empty space above/below
    return spec;
  }

  window.renderSpecMarkFlat = renderSpecMarkFlat;
  window.renderDuraMarkFlat = renderDuraMarkFlat;
})();
